// extracted by mini-css-extract-plugin
export var actionButton = "_dk-t";
export var buttonContainer = "_dk-0";
export var buttonContainer2 = "_dk-1";
export var buttonSection = "_dk-2";
export var details = "_dk-3";
export var dropdownItem = "_dk-5";
export var dropdownItemsContainer = "_dk-4";
export var fileInput = "_dk-r";
export var headerButton = "_dk-6";
export var icon = "_dk-7";
export var input = "_dk-8";
export var macroListItem = "_dk-9";
export var mainContent = "_dk-a";
export var microText = "_dk-b";
export var modal = "_dk-w";
export var optionsButton = "_dk-c";
export var paperclip = "_dk-s";
export var pillContent = "_dk-d";
export var preview = "_dk-e";
export var preview2 = "_dk-f";
export var quillEditor = "_dk-q";
export var selectedMacro = "_dk-g";
export var sidebar = "_dk-h";
export var sidebarHeader = "_dk-j";
export var sidebarList = "_dk-i";
export var sidebarListItem = "_dk-k";
export var sidebarSearch = "_dk-l";
export var snoozeDurationWrapper = "_dk-v";
export var statusPillContainer = "_dk-m";
export var tagsContainer = "_dk-n";
export var unselectedMacro = "_dk-o";
export var variable = "_dk-u";
export var wrapper = "_dk-p";